import { EventEmitter } from '@angular/core';

export const errorEventHandler = new EventEmitter<any>(true);
export const pushError = (err: any, ...args: any[]) => errorEventHandler.emit([err, ...args]);
